var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28216 4.99991C2.89568 7.19026 5.3832 8.4879 8.00009 8.4879C10.6168 8.4879 13.1043 7.19026 14.7178 4.99991C13.1049 2.80956 10.6176 1.5121 8.00009 1.5121C5.38245 1.5121 2.89492 2.80956 1.28216 4.99991ZM8.00009 9.5C4.90923 9.5 1.9882 7.92002 0.18611 5.2735L0 5.00009L0.18611 4.7265C1.98745 2.07998 4.90847 0.5 8.00009 0.5C11.0915 0.5 14.0126 2.07998 15.8141 4.7265L16 5.00009L15.8139 5.2735C14.0118 7.92002 11.0908 9.5 8.00009 9.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8989 5.00268C10.8989 6.44203 9.66235 7.60886 8.13696 7.60886C6.61157 7.60886 5.375 6.44203 5.375 5.00268C5.375 3.56333 6.61157 2.3965 8.13696 2.3965C9.66235 2.3965 10.8989 3.56333 10.8989 5.00268Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.35e1735aa3e18105366588bc51f79651.svg";
export { ForwardRef as ReactComponent };